export default __webpack_public_path__ + "static/media/page_of_swords.edb96c6d.png";